"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkToDoRetry = void 0;
var get_is_request_online_1 = require("./get-is-request-online");
var checkToDoRetry = function (_a) {
    var retry = _a.retry, retryCounter = _a.retryCounter, extraVerifyRetry = _a.extraVerifyRetry, formattedResponseData = _a.formattedResponseData, notRetryWhenOffline = _a.notRetryWhenOffline;
    // check if there was no connection
    var isOnlineRequest = (0, get_is_request_online_1.getIsRequestOnline)();
    if (!isOnlineRequest && notRetryWhenOffline) {
        return false;
    }
    if (typeof retry === 'undefined' ||
        typeof retryCounter === 'undefined' ||
        retryCounter >= retry) {
        return false;
    }
    if (extraVerifyRetry) {
        return extraVerifyRetry({ formattedResponseData: formattedResponseData });
    }
    return formattedResponseData.error;
};
exports.checkToDoRetry = checkToDoRetry;
